import { CheckpointResponse } from "../../api";

export const getAppKey = () => import.meta.env.VITE_APP_ID;

const turkishLiraFormatter = new Intl.NumberFormat("tr-TR", {
  style: "currency",
  currency: "TRY",
});

export const getFullDepositAmount = (response: CheckpointResponse) => {
  const { deposited_amount, currency } = response.result;
  const depostAsNumber = Number(deposited_amount);

  if (Number.isNaN(depostAsNumber)) {
    return `${deposited_amount} ${currency}`;
  }

  return turkishLiraFormatter.format(depostAsNumber);
};

export const numberFromEnv = (key: string, fallback: number) => {
  const envValue = import.meta.env[key];

  if (!envValue) return fallback;

  const valueAsNumber = Number(envValue);

  return !Number.isNaN(valueAsNumber) ? valueAsNumber : fallback;
};
